import React from 'react'
import DashboardTimelineItem from './DashboardTimelineItem'
import JustLookingModalBox from '../leave_plan_benefits/shared/JustLookingModalBox'

class DashboardTimelineItems extends React.Component {
  constructor (props) {
    super(props)

    this.infoTexts = [
      'Add Voluntary Tasks to your LeavePlan',
      'Set reminders for important tasks',
      'Enable sharing of key LeavePlan details with your Manager and HR (you share when you\'re ready)'
    ]
    this.state = {
      timelineItems: props.data,
      displayModal: {itemType: '', itemId: ''},
      activateLeavePlanModal: false
    }
  }

  componentDidMount () {
    this.subscribeToEvents()
  }

  componentWillUnmount () {
    this.unsubscribeFromEvents()
  }

  handleClick (itemType, itemId) {
    this.setState({displayModal: {itemType: itemType, itemId: itemId}})
  }

  updateTimelineItems () {
    $.getJSON('/timeline_items/dashboard_timeline_items', (updatedTimelineItems) => {
      this.setState({timelineItems: updatedTimelineItems})
    })
  }

  subscribeToEvents () {
    PubSub.subscribe('updateTimelineDataOnMilestoneSave', this.updateTimelineItems.bind(this))
    PubSub.subscribe('openJustLookingModal:onClick', (() => this.handleJustLookingClick(true)).bind(this))
  }

  unsubscribeFromEvents () {
    PubSub.unsubscribe('updateTimelineDataOnMilestoneSave')
    PubSub.unsubscribe('openJustLookingModal:onClick')
  }

  onHelpfulCheck (data) {
    this.setState(prevState => {
      return {
        ...prevState,
        timelineItems: prevState.timelineItems.map(item => {
          if (item.timeline_id === parseInt(data.item_id)) {
            item.helpful = data.helpful
          }
          return item
        })
      }
    })
  }

  handleJustLookingClick (value) {
    this.setState({activateLeavePlanModal: value})
  }

  renderTimelineItem (item, index) {
    return (
      <DashboardTimelineItem
        key={index}
        item={item}
        displayModal={this.state.displayModal}
        handleClick={this.handleClick.bind(this)}
        updateTimelineItems={this.updateTimelineItems.bind(this)}
        onHelpfulCheck={this.onHelpfulCheck.bind(this)}
        justLooking={this.props.just_looking}
        handleJustLookingClick={this.handleJustLookingClick.bind(this)}
        isLeavePlanPartner={this.props.isLeavePlanPartner}
      />
    )
  }

  renderActivateLeavePlanModal () {
    if (this.state.activateLeavePlanModal) {
      return (
        <JustLookingModalBox
          handleJustLookingClose={this.handleJustLookingClick.bind(this)}
          infoTexts={this.infoTexts}
          buttons={
            {
              cancel: 'Cancel',
              confirm: 'Activate LeavePlan'
            }
          }
        />
      )
    }
  }

  render () {
    return (
      <div>
        { this.state.timelineItems.map((item, index) => this.renderTimelineItem(item, index)) }
        { this.renderActivateLeavePlanModal() }
      </div>
    )
  }
}

export default DashboardTimelineItems
